import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cx from 'classnames';

import HubModel from 'models/hub';

const propTypes = {
  hub: PropTypes.instanceOf(HubModel).isRequired,
  destinations: PropTypes.instanceOf(Map).isRequired,
};

const defaultProps = {};

const MAX_ITEMS_PER_COLUMN = 5;

class PopularDestinationsCategory extends Component {
  constructor(props) {
    super(props);

    this.renderDestinationsList = this.renderDestinationsList.bind(this);
    this.renderExpandLink = this.renderExpandLink.bind(this);
    this.onExpanderClick = this.onExpanderClick.bind(this);

    this.state = {
      showAll: false,
    };
  }

  onExpanderClick() {
    this.setState({ showAll: !this.state.showAll });
  }

  renderDestinationsList() {
    const { destinations, hub } = this.props;

    return (
      destinations.valueSeq().map((destination, index) => {
        const destinationListClass = cx({
          'collapsed-item': (!this.state.showAll && index >= MAX_ITEMS_PER_COLUMN),
        });

        return (
          <li key={index} className={destinationListClass}>
            <a href={destination.linkUrl} className="text-color-slate" data-label={destination.name || hub.name}>
              {destination.name}
            </a>
          </li>
        );
      })
    );
  }

  renderExpandLink() {
    const expanderListItemClasses = cx({
      'collapse-items': this.state.showAll,
      'expand-items': !this.state.showAll,
      'text-color-green': true,
      'text-color-hover-green-lighten': true,
      'clickable': true,
    });
    const expanderSpanClasses = cx({
      'iconified': true,
      'iconified-green-double-chevron-up': this.state.showAll,
      'iconified-green-double-chevron-down': !this.state.showAll,
      'iconified-space-left': true,
    });
    const { destinations } = this.props;
    if (destinations.size <= MAX_ITEMS_PER_COLUMN) { return null; }

    return (
      <li
        className={expanderListItemClasses}
        onClick={this.onExpanderClick}
      >
        {this.state.showAll ? 'See less' : 'See more'}
        <span className={expanderSpanClasses} />
      </li>
    );
  }

  render() {
    const expanderListItemClasses = cx({
      'items-collapsed': !this.state.showAll,
      'destination-list': true,
      'text-weight-book': true,
    });

    return (
      <ul className={expanderListItemClasses}>
        {this.renderDestinationsList()}
        {this.renderExpandLink()}
      </ul>
    );
  }
}

PopularDestinationsCategory.propTypes = propTypes;
PopularDestinationsCategory.defaultProps = defaultProps;

export default PopularDestinationsCategory;
